module.exports = __webpack_public_path__ + "static/Averta-Semibold-eea894f9fee501ae1735c0522c1ed2bb.woff2";